import { ApiOutlined } from '@ant-design/icons';

import { ConnectivityToStaycation } from '../../_components/ConnectivityToStaycation/ConnectivityToStaycation';
import styles from '../StepChannelManager.module.scss';

export const StepChannelManagerHeader = () => (
  <div className={styles.header}>
    <ConnectivityToStaycation
      icon={<ApiOutlined className={styles.apiIcon} />}
    />

    <div className={styles.headerText}>
      <p className={styles.title}>
        Select your Channel Manager from the list below
      </p>
      <p className={styles.description}>
        Your Account Manager will be notified and will get back to you shortly
        to set up the integration.
      </p>
    </div>
  </div>
);
